import styled, { css } from 'styled-components';
import { lg, sm } from '@exonet/react-shared/lib/styled';
import { Gravatar } from '@exonet/react-shared/lib/Elements/Gravatar/styled';
import { hoverScale } from 'app/client/styled/animations';

export const Wrapper = styled.div`
  flex: 1 1 auto;
  align-self: stretch;
  display: flex;

  ${sm(css`
    position: relative;
  `)}
`;

export const Toggle = styled.button.attrs({
  type: 'button',
})`
  border: 0;
  background-color: var(--navbar-button-bg);
  flex: 1 1 var(--xs-header-height);
  align-self: stretch;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  min-width: 50px;

  ${sm(css`
    width: var(--lg-header-height);
  `)}

  &:focus {
    outline: none;
  }
`;

export const Icon = styled.span`
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;

  ${hoverScale({
    hoverScaleValue: 1.2,
    activeScaleValue: 1.05,
    durationMs: 200,
    triggerSelector: Toggle,
    targetSelector: '&',
  })}

  > svg {
    color: var(--navbar-icon-color);
    fill: var(--navbar-icon-color);
    display: block;
  }
`;

export const Menu = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: stretch;
  position: absolute;
  box-shadow:
    0 8px 24px rgba(0, 0, 0, 0.08),
    0 2px 4px rgba(0, 0, 0, 0.04);
  border-radius: var(--border-radius);

  z-index: var(--header-z-index);
  top: calc(var(--xs-header-height) + 1px);
  right: 0;
  left: auto;
  width: 260px;

  ${lg(css`
    top: calc(var(--lg-header-height) + 1px);
  `)}

  background-color: var(--navbar-menu-bg);
  border: 1px solid var(--navbar-menu-border-color);
`;

export const Header = styled.h4`
  padding: var(--xs-padding);
  padding-bottom: var(--xxs-padding-vertical);
  font-weight: 500;
  font-size: var(--xs-font-size);
  color: var(--menu-header-color);
  margin: 0;
  text-transform: uppercase;

  &:not(:first-child) {
    margin-top: var(--sm-padding-vertical);
  }
`;

export const Title = styled.div`
  font-weight: bold;
  font-size: var(--sm-font-size);
  margin-left: var(--xs-padding-horizontal);
`;

export const Item = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  color: var(--navbar-menu-link);
  min-width: 0;
  overflow: hidden;

  flex-flow: row nowrap;

  ${({ seperatorTop }) =>
    seperatorTop &&
    css`
      border-top: 1px solid var(--navbar-menu-border-color);
    `}

  ${({ seperatorBottom }) =>
    seperatorBottom &&
    css`
      border-bottom: 1px solid var(--navbar-menu-border-color);
    `}

  a, button {
    &,
    &:active,
    &:visited {
      flex: 1 1 auto;
      color: var(--navbar-menu-link);
      font-weight: normal;
      user-select: text;
      text-decoration: none;
      padding: var(--xs-padding);

      &::before {
        display: none;
      }

      &:hover {
        color: var(--navbar-menu-link-hover);
        background-color: var(--navbar-menu-link-hover-bg);
      }
    }

    > svg {
      margin-right: var(--xs-padding-horizontal);
      width: 16px;
    }
  }

  &.navbar-logout {
    border-radius: 0 0 var(--border-radius) var(--border-radius);

    :hover {
      button,
      button > svg {
        color: var(--dropdown-error-hover);
      }
    }

    button,
    button > svg {
      color: var(--dropdown-error);
      border-radius: 0 0 var(--border-radius) var(--border-radius);
    }
  }
`;

export const User = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;

  ${Gravatar} {
    margin: var(--xs-padding-horizontal);
    width: 46px;
    height: 46px;
  }

  > div:last-child {
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-start;
    justify-content: center;
    flex: 1 1 auto;
    min-width: 0;
    max-width: 100%;
    overflow: hidden;

    > span:first-child {
      display: block;
      font-weight: 500;
      line-height: normal;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 100%;
      padding-right: var(--xs-padding-horizontal);
    }

    > span:last-child {
      display: block;
      color: var(--text-muted);
      font-size: var(--sm-font-size);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 100%;
      padding-right: var(--xs-padding-horizontal);
    }
  }
`;

export const Footer = styled.div`
  margin-top: var(--lg-padding-vertical);
`;

export const Action = styled.button`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  border: 0;
  background: none;
  font: inherit;
  text-align: left;
  cursor: pointer;

  &:disabled {
    cursor: default;
    opacity: 0.6;
  }
`;
